import React from "react";
import styled from "styled-components";
import {PlanPricePreviewPropsType} from "./BridalPlanManagementsForm.types";
import {Badge} from "../../../../../components/ui-elements/Badge";
import {getPrimaryColor} from "../../../../../style/utils";

export const Price: React.FC<ComponentProps> = (props) => (
  <StyledComponent {...props}/>
)

type ComponentProps = PlanPricePreviewPropsType & {
  className?: string
  primaryColor: string
}

const Component: React.FC<ComponentProps> = ({
  displayType,
  targetNumberOfGuests,
  basePrice,
  baseDiscount,
  pricePerAdditionalGuest,
  discountPerGuest,
  className,
  primaryColor,
}) => (
  <div className={className}>
    {
      (() => {
        switch (displayType) {
          case 'fixed_people':
            return (
              <>
                <div className='primary-text'>
                  {
                    !!targetNumberOfGuests &&
                    <span
                      className='primary-text-prefix'>{targetNumberOfGuests.toLocaleString()}名様</span>
                  }
                  {
                    !!basePrice &&
                    <span className='primary-text-main'>
                      <span>
                        {(basePrice - (baseDiscount || 0)).toLocaleString()}
                      </span>
                      円
                    </span>
                  }
                </div>
              </>
            )
          case 'basic':
            return (
              <>
                <div className='primary-text'>
                  <span className='primary-text-prefix'>基本料金</span>
                  {
                    !!basePrice &&
                    <span className='primary-text-main'>
                      <span>
                        {(basePrice - (baseDiscount || 0)).toLocaleString()}
                      </span>
                      円
                    </span>
                  }
                </div>
                <div className='primary-text'>
                  <span className='primary-text-prefix'>＋ 人数×</span>
                  {
                    !!pricePerAdditionalGuest &&
                    <span
                      className='primary-text-main'
                    >
                      <span>{(pricePerAdditionalGuest - (discountPerGuest || 0)).toLocaleString()}</span>
                      円
                    </span>
                  }
                </div>
              </>
            )
          case 'fixed_price':
            return (
              <>
                <div className='primary-text'>
                  <span className='primary-text-prefix'>固定料金</span>
                  {
                    !!basePrice &&
                    <span className='primary-text-main'>
                      <span>
                        {(basePrice - (baseDiscount || 0)).toLocaleString()}
                      </span>
                      円
                    </span>
                  }
                </div>
              </>
            )
        }
      })()
    }
    {
      !!baseDiscount &&
      <Badge
        children={<span>割引あり</span>}
        primaryColor={primaryColor}
      />
    }
  </div>
)

const StyledComponent = styled(Component)`
  color: ${getPrimaryColor};
  display: flex;
  float: left;
  font-weight: bold;
  gap: 4px;
  flex-wrap: wrap;

  .primary-text {
    line-height: 1;
    font-size: 14px;
    float: left;
    @media (max-width: 520px) {
      margin-left: 0;
    }

    &-prefix {
      margin-right: 4px;
    }

    &-main {

      > span {
        font-size: 24px;
      }
    }

    &-suffix {
      margin-left: 4px;

      > span {
        text-decoration: line-through;
      }
    }
  }

  > span {
    margin-left: 4px;
  }
`;
